import { render, staticRenderFns } from "./workingHours.vue?vue&type=template&id=2395e4c4&scoped=true&"
import script from "./workingHours.vue?vue&type=script&lang=js&"
export * from "./workingHours.vue?vue&type=script&lang=js&"
import style0 from "./workingHours.vue?vue&type=style&index=0&id=2395e4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395e4c4",
  null
  
)

export default component.exports